import '../PublicPage.css';

export default function DubaiItineraryPage() {
    return (
        <div className="public-page dubai-page">
            <header className="public-hero" style={{
                backgroundImage: 'linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(/images/photo-1512453979798-5ea266f8880c.jpg',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white'
            }}>
                <div className="public-hero-content">
                    <h1 style={{ color: 'white' }}>Dubai: City of Gold & Future</h1>
                    <p style={{ color: 'rgba(255,255,255,0.9)' }}>Where ultra-modern skylines meet the rolling dunes of the desert.</p>
                </div>
            </header>

            <section className="public-section white-bg">
                <div className="section-inner">
                    <div className="story-grid">
                        <div className="modern-card">
                            <h3>Why visit Dubai?</h3>
                            <p>Dubai is a city of superlatives. Home to the world's tallest building, largest mall, and most luxurious hotels, it offers an architectural spectacle and a blend of global cultures like no other.</p>
                        </div>
                        <div className="modern-card">
                            <h3>Featured: 5 Days in Dubai</h3>
                            <p>From the Burj Khalifa to the Souks of Deira. Experience the contrast between the high-tech future and the rich heritage of the UAE.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="public-section slate-bg">
                <div className="section-inner">
                    <h2>Unmissable Experiences</h2>
                    <ul className="benefits-list">
                        <li><strong>Burj Khalifa</strong>: Sunset views from the top of the world.</li>
                        <li><strong>Desert Safari</strong>: Dune bashing and traditional Bedouin camping.</li>
                        <li><strong>Dubai Mall & Fountains</strong>: Shopping and the world's largest water show.</li>
                        <li><strong>Old Dubai</strong>: Crossing the Creek in an abra to explore the spice and gold souks.</li>
                    </ul>
                </div>
            </section>

            <section className="public-section white-bg" style={{ textAlign: 'center' }}>
                <div className="section-inner">
                    <h2>Ready for your Dubai adventure?</h2>
                    <p style={{ marginBottom: '32px' }}>Let Raisa AI design your perfect luxury or adventure-filled Dubai getaway.</p>
                    <button className="submit-btn-primary" style={{ maxWidth: '300px' }} onClick={() => window.location.href = '/?prompt=Plan a luxury 5-day trip to Dubai including a desert safari and Burj Khalifa sunset'}>
                        Plan my Dubai Trip
                    </button>
                </div>
            </section>
        </div>
    );
}
